export default "__VITE_ASSET__DYO$Gn61__"